import { DialogActions } from "@material-ui/core";
import { Dialog } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import * as React from "react";
import { Button } from "@material-ui/core";
import "./popup.scss";

interface PopupProps {
  open: boolean;
  changeOpenProp?: () => void;
  cancelClassName?: string;
  displayCancel?: boolean;
  cancel?: (() => void) | null;
  cancelText?: string;
  displayAction?: boolean;
  action?: (() => void) | null;
  actionText?: string;
  actionDisabled?: boolean;
  dialogContent: JSX.Element;
  className?: string;
}

export function Popup(props: PopupProps) {
  return (
    <Dialog
      className={`popup ${props.className || ""}`}
      open={props.open}
      onClose={props.changeOpenProp}
      fullWidth={true}
      disableBackdropClick={true}
    >
      <DialogContent >
        {props.dialogContent}
      </DialogContent>

      <DialogActions>
        {props.displayCancel && props.cancel && (
          <Button className={props.cancelClassName}
            variant="contained"
            onClick={props.cancel}>
            {props.cancelText}
          </Button>
        )}
        {props.displayAction && props.action && (
          <Button className="action-button"
            variant="contained"
            onClick={props.action}
            disabled={props.actionDisabled}>
            {props.actionText ?? "Zapisz"}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
